import React, { useRef } from 'react';
import JWPlayer from '@jwplayer/jwplayer-react';

const VideoPlayer = () => {
    const playerRef = useRef(null);

    const playerConfig = {
        playlist: [{
            file: process.env.REACT_APP_JW_STREAM_URL
        }],
        controls: true,
        muted: true,
        autostart: true
    };


    const onReady = (player) => {
        playerRef.current = player;
    };

    return (
        <div className="player-container">
            <JWPlayer
                library={`https://cdn.jwplayer.com/libraries/${process.env.REACT_APP_JW_KEY}.js`}
                config={playerConfig}
                onReady={onReady}
            />
        </div>
    );
};

export default VideoPlayer;
